module.exports = __webpack_public_path__ + "static/media/transactionSVG.2cdfab23.svg";